:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._emptyStateContainer_cjqjo_7 {
  display: flex;
  height: 100%;
  margin: 20px 0;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  pointer-events: all;
  z-index: 100; }
  ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16,
  ._emptyStateContainer_cjqjo_7 > .control-text {
    color: #3b4057; }
  ._emptyStateContainer_cjqjo_7._light_cjqjo_19 ._linksContainer_cjqjo_16,
  ._emptyStateContainer_cjqjo_7._light_cjqjo_19 > .control-text {
    color: #fff; }
  ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 {
    line-height: 18px;
    display: flex;
    gap: 30px;
    margin-top: 24px; }
    ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 ._linkButton_cjqjo_27 {
      overflow: hidden;
      width: 106px;
      min-height: 106px;
      border: 1px solid #d9d2ff;
      border-radius: 4px;
      padding: 14px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      background: #ffffff14;
      box-sizing: border-box;
      cursor: pointer; }
      ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 ._linkButton_cjqjo_27 ._linkButtonSymbol_cjqjo_42 {
        min-height: 30px; }
      ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 ._linkButton_cjqjo_27 span {
        font-size: 12px;
        padding: 1px;
        font-family: Madefor, Helvetica Neue, sans-serif; }
    ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 ._linkButton_cjqjo_27:hover {
      background: #d9d2ff14; }
    ._emptyStateContainer_cjqjo_7 ._linksContainer_cjqjo_16 > .control-text-button {
      vertical-align: bottom; }
